import React, { useEffect } from "react";

import "src/styles/globals.css";

import { setLocale } from "react-i18nify";
import dayjs from "dayjs";
import advancedFormat from "dayjs/plugin/advancedFormat";
import customParseFormat from "dayjs/plugin/customParseFormat";
import localeData from "dayjs/plugin/localeData";
import weekday from "dayjs/plugin/weekday";
import weekOfYear from "dayjs/plugin/weekOfYear";
import weekYear from "dayjs/plugin/weekYear";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";

import { ThemeProvider } from "@mui/material/styles";
import theme from "./styles/theme";

import { UploadContextProvider as UploadProvider } from "src/context/UploadProductContext";
import DialogProvider from "./context/DialogContext";
import AlertProvider from "./context/AlertContext/AlertContext";
import { BrowserRouter as Router } from "react-router-dom";
import LoadingProvider from "./context/LoadingContext";
import { AuthProvider } from "./hooks/useAuth";

import Layout from "./Layout";

import MuiThemeProvider from "material-ui/styles/MuiThemeProvider";

/**
 * @note for custom format date and time
 */
dayjs.extend(customParseFormat);
dayjs.extend(advancedFormat);
dayjs.extend(weekday);
dayjs.extend(localeData);
dayjs.extend(weekOfYear);
dayjs.extend(weekYear);
dayjs.extend(timezone);
dayjs.extend(utc);

function App() {
  useEffect(() => {
    const test = () => {
      if (typeof window !== "undefined") {
        const lang = localStorage.getItem("language");

        if (!lang) {
          localStorage.setItem("language", "th");
          return "th";
        }

        return lang;
      }
    };

    setLocale(test());
  });

  return (
    <Router>
      <AuthProvider>
        <ThemeProvider theme={theme}>
          <MuiThemeProvider>
            <LoadingProvider>
              <UploadProvider>
                <AlertProvider>
                  <DialogProvider>
                    <Layout />
                  </DialogProvider>
                </AlertProvider>
              </UploadProvider>
            </LoadingProvider>
          </MuiThemeProvider>
        </ThemeProvider>
      </AuthProvider>
    </Router>
  );
}

export default App;
